<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="dialogRef.close()"
  >
    Close
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>

  <h2 class="cg-dialog__header">Privacy</h2>

  <mat-dialog-content>
    <p>
      <a
        href="https://www.evernorth.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        >Privacy Policy</a
      >
    </p>
    <p>
      <a
        href="https://www.evernorth.com/notice-of-privacy-practices"
        target="_blank"
        rel="noopener noreferrer"
        >Notice of Privacy Practices</a
      >
    </p>
    <p>
      <a
        href="https://static.evernorth.com/assets/evernorth/member/pdf/privacy/evernorth_direct_health_notice_of_privacy_practice.pdf"
        target="_blank"
        rel="noopener noreferrer"
        >Evernorth Direct Health Privacy Notice</a
      >
    </p>
    <p>
      <a
        [href]="
          '/pdf/resourceLibrary/Privacy/CignaHealthServiceProviderWebsiteNoticeNYDomViolence071213.pdf'
            | resourceLink: { targetApp: 'chcp', type: 'file' }
            | async
        "
        target="_blank"
        >Cigna Health Services notice</a
      ><br />
      Protocols for Victims of Domestic Violence Residing in New York.
    </p>
  </mat-dialog-content>
</div>
